<template>
  <div>
    <Modal v-model="userForm" title="修改用户" width="600" :mask-closable="false">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="110">
        <Row>
            <Col span="24">
                <FormItem label="账号" prop="userId" :class="{requireStar:true}" >
                  <Input v-model="formValidate.userId" :readonly="true" :maxlength="10" ></Input>
                </FormItem>
            </Col>
        </Row>
        <Row>
            <Col span="24">
                  <FormItem label="用户类型" prop="userType">
                    <RadioGroup v-model="formValidate.userType">
                      <Radio label="4">管理员</Radio>
                      <Radio label="2">操作者</Radio>
                    </RadioGroup>
                  </FormItem>
            </Col>
        </Row>
        <Row>
            <Col span="24">
                  <FormItem label="特殊权限(复选)" prop="role">
                    <CheckboxGroup v-model="formValidate.role" >
                      <Checkbox label="2">资产管理</Checkbox>
                    </CheckboxGroup>
                  </FormItem>
            </Col>
        </Row>
        <Row>
            <Col span="24">
                  <FormItem label="用户描述" prop="userDescription">
                    <Input v-model="formValidate.userDescription" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="Enter something..."></Input>
                  </FormItem>
            </Col>
        </Row>
      </Form>
      <!--自定义按钮，解决自带按钮，点击就关闭的问题-->
      <div slot="footer">
        <Button type="text" size="large" @click="cancle">取消</Button>
        <Button type="primary" size="large" @click="handleSubmit('formValidate')">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
  export default {
    components:{
    },
    data() {
      return {
        userForm: false,
        title: '',
        show: true,
        showCity: false,
        showDist: false,
        showBar: false,
        cityList: [],
        distList: [],
        roleShow1: false,
        roleShow2: false,
        roleShow3: false,
        roleShow4: false,
        roleShow5: false,
        formValidate: {
          id: '',
          city: '',
          dist: '',
          userId: '',
          userPassword: '',
          userPassword2: '',
          regionCode: '',
          userState:'',
          userType:'',
          userDescription:'',
          LastLogonTime:'',
          role:[],
          assetsManage:'',
        },
        ruleValidate: {
          userType: [{
            required: true,
            message: '用户类型不能为空',
            trigger: 'change'
          }],
        },
      }
    },

    methods: {
      openModal(row) {
        
        this.userForm = true
        this.handleReset("formValidate");
        this.initUpdate(row)
      },
      //修改初始化
      initUpdate(row){
            let url = `/province/sys/user/${row.id}`;
            this.req({
              url: url,
              method: 'get',
            }).then(resp => {
                let user = resp.data.data;
               // console.log(user)
                this.formValidate.id = user.id
                this.formValidate.userId = user.userId
                this.formValidate.regionCode = user.regionCode
                this.formValidate.userDescription = user.userDescription
                this.formValidate.userType = user.userType
                this.formValidate.role = user.roleID.split(',')
              
            }).catch(error => {
                this.reponseData = "发生错误，无法显示内容"
            })
      },
      handleSubmit(name) {

        this.$refs[name].validate((valid) => {
          if (valid) {
            let url = "/province/sys/user/save";
            let myData = {
              id: this.formValidate.id,
              userId: this.formValidate.userId,
              regionCode: this.formValidate.regionCode,
              userType: this.formValidate.userType,
              userDescription: this.formValidate.userDescription,
              roleID: this.formValidate.role.join(","),
              assetsManage: 1,
            }
            this.req({
              url: url,
              method: 'post',
              data: myData
            }).then(response => {
              if (response.status == 200) {
                this.$Message.success('保存成功!');
                this.$parent.loadPage();
              } else {
                this.$Message.error('服务器错误:' + response.status);
              }
              this.userForm = false;
            }).catch(error => {
              this.reponseData = "发生错误，无法显示内容"
            })
          } else {
            return;
          }
        }) 
      },
      handleReset(name) {
         if (this.$refs[name]!==undefined) {
              this.$refs[name].resetFields();
          }
      },
      cancle() {
        this.userForm = false;
      },
    },
    mounted() {
    },
  }
</script>
<style>
  /*动态必填项className*/
  .requireStar .ivu-form-item-label:before{
    content: '*';
    display: inline-block;
    margin-right: 4px;
    line-height: 1;
    font-family: SimSun;
    font-size: 12px;
    color: #ed4014;
  }
</style>


// WEBPACK FOOTER //
// src/pages/platform/sys/user/UserFormUpdateDist.vue